import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputStandardComponent } from './components/input-standard/input-standard.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { MatIconModule } from '@angular/material/icon';
import { DsrIconsModule } from '@desyre/icons-angular';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { MessagePopupComponent } from './components/message-popup/message-popup.component';
import { NotificationMessagePopupComponent } from './components/notification-message-popup/notification-message-popup.component';
import { SessionPopupComponent } from './components/session-popup/session-popup.component';
import { FileDownloadComponent } from './components/file-download/file-download.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { PaymentSummaryPopupComponent } from './components/payment-summary-popup/payment-summary-popup.component';
import { EmailSelectionPopupComponent } from './components/email-selection-popup/email-selection-popup.component';
import { FormatMobileNumberPipe } from './pipes/formatMobile-number.pipe';
import { FormatPricePipe } from './pipes/formatPrice.pipe';
import { PaymentAddressPopupComponent } from './components/payment-address-popup/payment-address-popup.component';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { VatPopupComponent } from './components/vat-popup/vat-popup.component';

@NgModule({
  declarations: [
    InputStandardComponent,
    BreadcrumbComponent,
    MessagePopupComponent,
    NotificationMessagePopupComponent,
    SessionPopupComponent,
    FileDownloadComponent,
    ConfirmationPopupComponent,
    PaymentSummaryPopupComponent,
    EmailSelectionPopupComponent,
    FormatMobileNumberPipe,
    FormatPricePipe,
    PaymentAddressPopupComponent,
    VatPopupComponent
  ],
  imports: [
    CommonModule,
    DsrIconsModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatDialogModule
  ],
  exports: [
    InputStandardComponent,
    BreadcrumbComponent,
    FileDownloadComponent,
    // Re-export TranslateModule so that any module importing SharedModule
    // has access to the translate pipe without needing to import it separately.
    TranslateModule
  ]
})

export class SharedModule { }